import { render } from "./HealthCare.vue?vue&type=template&id=36db4ea8&scoped=true"
import script from "./HealthCare.vue?vue&type=script&lang=js"
export * from "./HealthCare.vue?vue&type=script&lang=js"

import "./HealthCare.vue?vue&type=style&index=0&id=36db4ea8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36db4ea8"]])

export default __exports__